import React, { useEffect, useState } from 'react'
import { useDashboardContext } from '../../../../contexts/NewDashboardContext';
import { alertV2, machineProfile } from '../../../../api';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import { Card, CardBody } from "../../../../components/card/card";
import { CardExpandToggler } from "../../../../components/card/card";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const MachineUptime  = ({ }) => {
    const { dateRangeOverview } = useDashboardContext();
    const [chartData, setChartData] = useState(null);

    // Get theme colors from CSS variables
    const getThemeColors = () => {
        const bodyBg = getComputedStyle(document.body)
            .getPropertyValue("--bs-body-bg")
            .trim();
        const textColor = getComputedStyle(document.body)
            .getPropertyValue("--bs-body-color")
            .trim();
        const gridColor = getComputedStyle(document.body)
            .getPropertyValue("--bs-border-color")
            .trim();
        const themeColor = getComputedStyle(document.body)
            .getPropertyValue("--bs-theme")
            .trim();
        
        return { bodyBg, textColor, gridColor,themeColor };
    };

    const { bodyBg, textColor, gridColor,themeColor } = getThemeColors();

    const options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        animation: {
            duration: 1000,
            easing: 'easeOutBounce'
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: "Machine Sensor Uptime",
                color: textColor,
                font: {
                  size: 14,
                  weight: "bold",
                },
              },
          
            tooltip: {
                backgroundColor: bodyBg,
                titleColor: textColor,
                bodyColor: textColor,
                borderColor: gridColor,
                borderWidth: 1,
                callbacks: {
                    label: function(context) {
                        const value = context.parsed.y;
                        return `${context.dataset.label}: ${value.toLocaleString()} %`;
                    }
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: textColor,
                    font: {
                        size: 12
                    }
                },
                grid: {
                    color:'#4b4b4b',
                    
                }
            },
            y: {
                beginAtZero: true,
               
                ticks: {
                    color: textColor,
                    font: {
                        size: 12
                    },
                    stepSize: 1,
                    
                },
                grid: {
                    color: '#4b4b4b',
                    drawBorder: false
                }
            }
        }
    };

    async function getData() {
        try {
            const result = await machineProfile.list({
                uptime_start_date: dateRangeOverview?.startDate,
                uptime_end_date: dateRangeOverview?.endDate,
            });
            const body = await result.json();
            
            // Process the data to create chart data
            processChartData(body.data);
        } catch (error) {
            console.error('Error fetching alarm data:', error);
            // Use mock data for demonstration
            createMockChartData();
        }
    }

    const processChartData = (apiData) => {
        if (!apiData || !Array.isArray(apiData)) {
            console.log('No valid API data, using mock data');
            createMockChartData();
            return;
        }


        const labels = [];
        const data = [];

        apiData.forEach(machine => {
            labels.push(machine.machine_name);

            const all_sensor_uptimes = [];
            machine.machine_elements.forEach(element => {
                
                const deployment = element.deployments[0]
                if (deployment) {
                    const sensor_uptimes = deployment.sensor.sensor_uptime
                    all_sensor_uptimes.push(...sensor_uptimes)
                }

            });

            const total_on = all_sensor_uptimes.filter(uptime => uptime.on_off_status === 'true').length
            const total_sensor_uptimes = all_sensor_uptimes.length
            const uptime = (total_on / total_sensor_uptimes) * 100
            data.push(uptime)


        });



      

       

      

        

        const chartData = {
            labels: labels,
            datasets: [
                {
                    label: `Machine Sensor Uptime`,
                    data: data,
                    borderColor: '#007bff',
                    backgroundColor: '#007bff',
                    borderWidth: 1,
                    pointRadius: 4,
                    pointHoverRadius: 8,
                    tension: 0.1,
                    fill: false
                }
            ]
        };
        
        setChartData(chartData);
    };

    const createMockChartData = () => {
        const data = {
          labels: [
        
          ],
          datasets: [
            {
              label: "Machine Sensor Uptime",
              data: [],
              borderColor: "#007bff",
              backgroundColor: "#007bff",
              borderWidth: 1,
              pointRadius: 4,
              pointHoverRadius: 8,
              tension: 0.1,
              fill: false,
            },
          ],
        };
        setChartData(data);
    };

    useEffect(() => {
        getData();
    }, [dateRangeOverview]);

    // If no data is available yet, show loading
    if (!chartData) {
        return (
            <div style={{ 
                height: '300px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                backgroundColor: bodyBg,
                borderRadius: '8px',
                border: `1px solid ${gridColor}`
            }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div>  
            <Card>
                <CardBody>
                    <div className="d-flex justify-content-end">
                        <CardExpandToggler />
                    </div>
                    <div style={{ position: "relative", height: "470px", width: "100%" }}>
                        <Bar options={options} data={chartData} />
                    </div>
                </CardBody>
            </Card>
        </div>
    );
}

    